import React, { useEffect, useState } from 'react';
import { Button, Card } from '../../shared/components';
import { api } from '../../utils/api';
import WordBrowser from './WordBrowser';
import './Vocabulary.css';

export default function Vocabulary() {
  const [view, setView] = useState('today');
  const [word, setWord] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    loadToday();
  }, []);

  function loadToday() {
    setLoading(true);
    api
      .get('/api/vocab/today')
      .then((data) => {
        setWord(data);
        setLoading(false);
      })
      .catch(() => {
        setError("Unable to load today's word right now.");
        setLoading(false);
      });
  }

  async function markStatus(status) {
    setSaving(true);
    setError('');
    try {
      await api.post(`/api/vocab/${word.id}/review`, { status });
      loadToday();
    } catch (err) {
      setError('Unable to save your progress right now.');
    } finally {
      setSaving(false);
    }
  }

  if (view === 'browse') {
    return <WordBrowser onExit={() => setView('today')} />;
  }

  return (
    <div className="vocabulary-page">
      <h1>Daily Vocabulary Builder</h1>
      <p className="vocabulary-intro">One high-frequency SAT word a day, drawn from the full word bank below.</p>
      {error && <p className="vocabulary-error">{error}</p>}

      {loading ? (
        <p>Loading today&rsquo;s word&hellip;</p>
      ) : word ? (
        <>
          <div className="vocabulary-streak">
            <span className="vocabulary-streak-count">{word.streak}</span>
            <span className="vocabulary-streak-label">
              day{word.streak === 1 ? '' : 's'} in a row
              {!word.reviewedToday && word.streak > 0 ? ' — mark today’s word to keep it going' : ''}
            </span>
          </div>

          <Card className="vocabulary-word-card">
            <p className="vocabulary-word">{word.word}</p>
            <p className="vocabulary-pos">{word.part_of_speech}</p>
            <p className="vocabulary-definition">{word.definition}</p>
            <p className="vocabulary-example">&ldquo;{word.example}&rdquo;</p>
          </Card>

          <div className="vocabulary-actions">
            <Button variant="secondary" disabled={saving} onClick={() => markStatus('review')}>
              Still learning this
            </Button>
            <Button disabled={saving} onClick={() => markStatus('known')}>
              I know this word
            </Button>
          </div>

          {word.status !== 'unseen' && (
            <p className="vocabulary-status">
              Marked as {word.status === 'known' ? 'known' : 'still learning'} today.
            </p>
          )}
        </>
      ) : (
        <p>No word available today.</p>
      )}

      <button className="vocabulary-browse-link" onClick={() => setView('browse')}>
        Browse the full word bank{word ? ` (${word.totalWords} words)` : ''} &rarr;
      </button>
    </div>
  );
}
